exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Select.is-open{z-index:1000 !important}", ""]);

// exports
